import { render } from "./ContentContact.vue?vue&type=template&id=4fa44948&scoped=true&ts=true"
import script from "./ContentContact.vue?vue&type=script&lang=ts"
export * from "./ContentContact.vue?vue&type=script&lang=ts"

import "./ContentContact.vue?vue&type=style&index=0&id=4fa44948&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa44948"]])

export default __exports__